import { render, staticRenderFns } from "./SnapForm.vue?vue&type=template&id=80d8c6d6"
import script from "./SnapForm.vue?vue&type=script&lang=js"
export * from "./SnapForm.vue?vue&type=script&lang=js"
import style0 from "./SnapForm.vue?vue&type=style&index=0&id=80d8c6d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports